/* Wishlist — Birdie Shots */
(function() {
  const WISHLIST_KEY = 'bs_wishlist';

  function getWishlist() {
    try { return JSON.parse(localStorage.getItem(WISHLIST_KEY)) || []; }
    catch { return []; }
  }

  function saveWishlist(list) {
    localStorage.setItem(WISHLIST_KEY, JSON.stringify(list));
    updateWishlistCount(list.length);
    syncWithServer(list);
  }

  function updateWishlistCount(count) {
    const el = document.getElementById('wishlist-count');
    if (el) {
      el.textContent = count;
      el.style.display = count > 0 ? 'flex' : 'none';
    }
  }

  function syncWithServer(list) {
    if (!window.Shopify?.customerId) return;
    fetch('/apps/birdie-shots/api/wishlist/sync', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ customer_id: window.Shopify.customerId, items: list })
    }).catch(() => {});
  }

  function toggleWishlist(productId) {
    const list = getWishlist();
    const idx = list.indexOf(String(productId));
    if (idx > -1) {
      list.splice(idx, 1);
      window.showToast('Removed from wishlist', 'success');
    } else {
      list.push(String(productId));
      window.showToast('Added to wishlist! ♥', 'success');
    }
    saveWishlist(list);
    return list.includes(String(productId));
  }

  function isWishlisted(productId) {
    return getWishlist().includes(String(productId));
  }

  // Update button states
  function updateButtons() {
    document.querySelectorAll('[data-product-id]').forEach(btn => {
      const id = btn.dataset.productId;
      if (id) {
        btn.classList.toggle('is-wishlisted', isWishlisted(id));
        if (btn.classList.contains('is-wishlisted')) {
          btn.innerHTML = '♥ Saved';
        }
      }
    });
  }

  document.addEventListener('click', function(e) {
    const btn = e.target.closest('#wishlist-product-btn, .wishlist-btn[data-product-id]');
    if (!btn) return;
    const productId = btn.dataset.productId;
    if (!productId) return;

    const wishlisted = toggleWishlist(productId);
    btn.classList.toggle('is-wishlisted', wishlisted);
    btn.innerHTML = wishlisted ? '♥ Saved' : '♡ Save';
  });

  // Init
  updateButtons();
  updateWishlistCount(getWishlist().length);

  window.birdieWishlist = { get: getWishlist, toggle: toggleWishlist, isWishlisted };
})();
